import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "bg-white rounded-lg shadow-md" }
const _hoisted_3 = { class: "p-4 border-b border-gray-200" }
const _hoisted_4 = { class: "mt-4 space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = {
  class: "display table-striped table-hover table-bordered table",
  id: "basic-1"
}
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_15 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_16 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_17 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_18 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_20 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-900" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_26 = ["onClick", "title"]
const _hoisted_27 = { class: "ml-1 text-xs" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "p-4 border-t border-gray-200" }
const _hoisted_35 = { class: "text-sm text-gray-600" }
const _hoisted_36 = {
  class: "modal fade",
  id: "detailsModal",
  tabindex: "-1",
  "aria-labelledby": "detailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_37 = { class: "modal-dialog modal-lg" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_40 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_41 = { class: "col-span-2 md:col-span-1" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = { class: "col-span-2 md:col-span-1" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_46 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" }
const _hoisted_47 = { class: "h-48 w-full rounded-lg overflow-hidden shadow-lg" }
const _hoisted_48 = ["src", "alt", "onClick"]
const _hoisted_49 = { class: "absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  class: "modal fade",
  id: "rejectModal",
  tabindex: "-1",
  "aria-labelledby": "rejectModalLabel",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = { class: "mb-3" }
const _hoisted_56 = { class: "modal-footer" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  class: "modal fade",
  id: "galleryModal",
  tabindex: "-1",
  "aria-labelledby": "galleryModalLabel",
  "aria-hidden": "true"
}
const _hoisted_59 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_60 = { class: "modal-content bg-gray-900" }
const _hoisted_61 = { class: "modal-header border-0 bg-gray-900 text-white" }
const _hoisted_62 = {
  class: "modal-title",
  id: "galleryModalLabel"
}
const _hoisted_63 = { class: "text-gray-400 ml-2" }
const _hoisted_64 = { class: "modal-body p-0 bg-gray-900" }
const _hoisted_65 = { class: "relative gallery-container" }
const _hoisted_66 = { class: "image-viewer" }
const _hoisted_67 = {
  key: 0,
  class: "image-loading"
}
const _hoisted_68 = {
  key: 1,
  class: "image-error"
}
const _hoisted_69 = ["src"]
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["disabled"]
const _hoisted_72 = {
  key: 2,
  class: "thumbnails-container"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["src", "alt"]
const _hoisted_75 = {
  key: 0,
  class: "thumbnail-overlay"
}
const _hoisted_76 = { class: "thumbnail-number" }
const _hoisted_77 = { class: "modal-footer border-0 bg-gray-900 text-white" }
const _hoisted_78 = ["disabled"]

import { ref, onMounted, computed, onUnmounted } from 'vue'
import axios from 'axios'
import { Modal } from 'bootstrap'

interface KytId {
  _id: string
  siteName: string
  date: string
  status: string
}

interface EmpId {
  _id: string
  email: string
}

interface TransferRequest {
  _id: string
  kytId: KytId
  siteName: string
  isCompleted: boolean
  kytPriority: string
  empId: string
  empName: string
  requestedBy: string
  takledWithEmp: boolean
  hasEmpAccepted: boolean
  status: string
  type: string
  reason: string
  images: string[]
  transferTo: string
  createdAt: string
  updatedAt: string
  __v: number
  kytLogNo: string
  approvedBy: {
    name: string
    email: string
  } | null
  approvedAt: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'kyt-transfer',
  setup(__props) {

const transferRequests = ref<TransferRequest[]>([])
const rejectReason = ref('')
const selectedRequestId = ref('')
const selectedRequest = ref<TransferRequest | null>(null)
let rejectModal: any = null
let detailsModal: any = null
let galleryModal: any = null
const baseUrl = process.env.VUE_APP_BASE_URL
const token = localStorage.getItem('token')

const galleryImages = ref<string[]>([])
const currentImageIndex = ref(0)

const currentGalleryImage = computed(() => {
  return galleryImages.value[currentImageIndex.value] || ''
})

// Add these new refs
const isImageLoading = ref(true)
const imageLoadError = ref(false)
const thumbnailsContainer = ref<HTMLElement | null>(null)

// Add filter states
const filters = ref({
  employeeName: '',
  siteName: '',
  startDate: '',
  endDate: ''
})

// Add computed property for filtered requests
const filteredRequests = computed(() => {
  return transferRequests.value.filter(request => {
    const matchesEmployeeName = !filters.value.employeeName || 
      request.empName.toLowerCase().includes(filters.value.employeeName.toLowerCase())
    
    const matchesSiteName = !filters.value.siteName || 
      request.siteName.toLowerCase().includes(filters.value.siteName.toLowerCase())
    
    const requestDate = new Date(request.createdAt)
    const startDate = filters.value.startDate ? new Date(filters.value.startDate) : null
    const endDate = filters.value.endDate ? new Date(filters.value.endDate) : null
    
    const matchesDateRange = (!startDate || requestDate >= startDate) && 
      (!endDate || requestDate <= new Date(endDate.setHours(23, 59, 59, 999)))
    
    return matchesEmployeeName && matchesSiteName && matchesDateRange
  })
})

// Add keyboard navigation
const handleKeyPress = (e: KeyboardEvent) => {
  if (galleryModal && galleryImages.value.length > 1 && !isImageLoading.value) {
    if (e.key === 'ArrowLeft') {
      previousImage()
    } else if (e.key === 'ArrowRight') {
      nextImage()
    }
  }
}

// Add these new methods
const handleImageLoad = () => {
  isImageLoading.value = false
  imageLoadError.value = false
}

const handleImageError = () => {
  isImageLoading.value = false
  imageLoadError.value = true
}

const retryLoadImage = () => {
  isImageLoading.value = true
  imageLoadError.value = false
  // Force image reload by creating a new URL with cache buster
  const currentImage = galleryImages.value[currentImageIndex.value]
  galleryImages.value[currentImageIndex.value] = `${currentImage}?t=${Date.now()}`
}

const setCurrentImage = (index: number) => {
  isImageLoading.value = true
  imageLoadError.value = false
  currentImageIndex.value = index
  scrollThumbnailIntoView(index)
}

const scrollThumbnailIntoView = (index: number) => {
  if (!thumbnailsContainer.value) return
  
  const thumbnailElement = thumbnailsContainer.value.children[index] as HTMLElement
  if (!thumbnailElement) return

  const containerWidth = thumbnailsContainer.value.clientWidth
  const thumbnailWidth = thumbnailElement.offsetWidth
  const scrollLeft = thumbnailElement.offsetLeft - (containerWidth / 2) + (thumbnailWidth / 2)
  
  thumbnailsContainer.value.scrollTo({
    left: scrollLeft,
    behavior: 'smooth'
  })
}

onMounted(() => {
  fetchTransferRequests()
  rejectModal = new Modal(document.getElementById('rejectModal'))
  detailsModal = new Modal(document.getElementById('detailsModal'))
  galleryModal = new Modal(document.getElementById('galleryModal'))
  
  // Add keyboard event listener
  window.addEventListener('keydown', handleKeyPress)
})

// Clean up event listener
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyPress)
})

const fetchTransferRequests = async () => {
  try {
    const response = await axios.get(`${baseUrl}api/operation/kyt/transfer-requests`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    if (response.data.success) {
      transferRequests.value = response.data.data
    }
  } catch (error) {
    console.error('Error fetching transfer requests:', error)
    alert('Error fetching transfer requests')
  }
}

const handleApprove = async (requestId: string) => {
  try {
    const response = await axios.put(
      `${baseUrl}api/operation/kyt/transfer-requests/approve/${requestId}`,
      {}, // Empty body
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    )
    if (response.data.success) {
      alert('Transfer request approved successfully')
      await fetchTransferRequests()
    }
  } catch (error: any) {
    console.error('Error approving request:', error)
    alert(error.response?.data?.message || 'Error approving request')
  }
}

const openRejectModal = (requestId: string) => {
  selectedRequestId.value = requestId
  rejectReason.value = ''
  rejectModal?.show()
}

const handleReject = async () => {
  if (!rejectReason.value) {
    alert('Please provide a reason for rejection')
    return
  }

  try {
    const response = await axios.put(
      `${baseUrl}api/operation/kyt/transfer-requests/reject/${selectedRequestId.value}`,
      { reason: rejectReason.value },
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    )
    if (response.data.success) {
      alert('Transfer request rejected successfully')
      rejectModal?.hide()
      await fetchTransferRequests()
    }
  } catch (error: any) {
    console.error('Error rejecting request:', error)
    alert(error.response?.data?.message || 'Error rejecting request')
  }
}

const openDetailsModal = (request: TransferRequest) => {
  selectedRequest.value = request
  detailsModal?.show()
}

const openImageInNewTab = (imageUrl: string) => {
  window.open(imageUrl, '_blank')
}

const openGalleryModal = (images: string[], startIndex: number = 0) => {
  galleryImages.value = images
  isImageLoading.value = true
  imageLoadError.value = false
  currentImageIndex.value = startIndex
  galleryModal?.show()
}

const nextImage = () => {
  if (isImageLoading.value) return
  const nextIndex = currentImageIndex.value < galleryImages.value.length - 1 ? currentImageIndex.value + 1 : 0
  setCurrentImage(nextIndex)
}

const previousImage = () => {
  if (isImageLoading.value) return
  const prevIndex = currentImageIndex.value > 0 ? currentImageIndex.value - 1 : galleryImages.value.length - 1
  setCurrentImage(prevIndex)
}

const formatDate = (dateString: string | null) => {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-xl font-semibold text-gray-800" }, "KYT Transfer Requests", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Employee Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.employeeName) = $event)),
                class: "form-control",
                placeholder: "Search by employee name"
              }, null, 512), [
                [_vModelText, filters.value.employeeName]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Site Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.siteName) = $event)),
                class: "form-control",
                placeholder: "Search by site name"
              }, null, 512), [
                [_vModelText, filters.value.siteName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Start Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.startDate) = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, filters.value.startDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "End Date", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.endDate) = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, filters.value.endDate]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Sl No."),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Site Name"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Employee Name"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Requested By"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Transfer To"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Priority"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Status"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Reason"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Date"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Approved By"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Approved At"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Images"),
              _createElementVNode("th", {
                class: "sorting_asc text-nowrap",
                scope: "col"
              }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRequests.value, (request, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: request._id,
                class: "hover:bg-gray-50"
              }, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(request.siteName), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(request.empName), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(request.requestedBy), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(request.transferTo || '-'), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(request.kytPriority), 1),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                  'px-2 py-1 text-xs font-semibold rounded-full text-black': true,
                  'bg-yellow-100': request.status === 'Pending',
                  'bg-green-100': request.status === 'Approved',
                  'bg-red-100': request.status === 'Rejected'
                })
                  }, _toDisplayString(request.status), 3)
                ]),
                _createElementVNode("td", _hoisted_20, _toDisplayString(request.reason), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(formatDate(request.createdAt)), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(request.approvedBy?.name || '-'), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(formatDate(request.approvedAt)), 1),
                _createElementVNode("td", _hoisted_24, [
                  (request.images && request.images.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openGalleryModal(request.images)),
                          class: "btn btn-light btn-sm",
                          title: `View ${request.images.length} Image${request.images.length > 1 ? 's' : ''}`
                        }, [
                          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-images" }, null, -1)),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(request.images.length), 1)
                        ], 8, _hoisted_26)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
                ]),
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (openDetailsModal(request)),
                    class: "btn btn-info btn-sm",
                    title: "View Details"
                  }, _cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                  ]), 8, _hoisted_30),
                  (request.status === 'Pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (handleApprove(request._id)),
                        class: "btn btn-success btn-sm"
                      }, " Approve ", 8, _hoisted_31))
                    : _createCommentVNode("", true),
                  (request.status === 'Pending')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (openRejectModal(request._id)),
                        class: "btn btn-danger btn-sm"
                      }, " Reject ", 8, _hoisted_32))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (filteredRequests.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, _cache[13] || (_cache[13] = [
                  _createElementVNode("td", {
                    colspan: "13",
                    class: "text-center py-4 text-muted"
                  }, "No transfer requests found", -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("p", _hoisted_35, " Showing " + _toDisplayString(filteredRequests.value.length) + " of " + _toDisplayString(transferRequests.value.length) + " total requests ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", {
              class: "modal-title",
              id: "detailsModalLabel"
            }, "Transfer Request Details"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (selectedRequest.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[24] || (_cache[24] = _createElementVNode("h6", { class: "font-semibold" }, "Basic Information", -1)),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("p", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Site Name:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.siteName), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Employee Name:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.empName), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Requested By:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.requestedBy), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Transfer To:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.transferTo || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Priority:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.kytPriority), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Status:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.status), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("strong", null, "Type:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.type), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Reason:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.reason), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[23] || (_cache[23] = _createElementVNode("strong", null, "Created At:", -1)),
                        _createTextVNode(" " + _toDisplayString(formatDate(selectedRequest.value.createdAt)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _cache[31] || (_cache[31] = _createElementVNode("h6", { class: "font-semibold" }, "Additional Information", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("p", null, [
                        _cache[25] || (_cache[25] = _createElementVNode("strong", null, "KYT Log No:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.kytLogNo || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Talked with Employee:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.takledWithEmp ? 'Yes' : 'No'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Employee Accepted:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.hasEmpAccepted ? 'Yes' : 'No'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Completed:", -1)),
                        _createTextVNode(" " + _toDisplayString(selectedRequest.value.isCompleted ? 'Yes' : 'No'), 1)
                      ]),
                      (selectedRequest.value.approvedBy)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("p", null, [
                              _cache[29] || (_cache[29] = _createElementVNode("strong", null, "Approved By:", -1)),
                              _createTextVNode(" " + _toDisplayString(selectedRequest.value.approvedBy.name), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Approved At:", -1)),
                              _createTextVNode(" " + _toDisplayString(formatDate(selectedRequest.value.approvedAt)), 1)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (selectedRequest.value.images && selectedRequest.value.images.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _cache[34] || (_cache[34] = _createElementVNode("h6", { class: "font-semibold mb-3" }, "Attached Images", -1)),
                        _createElementVNode("div", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRequest.value.images, (image, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "relative group"
                            }, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("img", {
                                  src: image,
                                  alt: 'Image ' + (index + 1),
                                  class: "w-full h-full object-contain bg-gray-100",
                                  onClick: ($event: any) => (openGalleryModal(selectedRequest.value.images, index))
                                }, null, 8, _hoisted_48)
                              ]),
                              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300 rounded-lg" }, null, -1)),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (openImageInNewTab(image)),
                                  class: "bg-white text-gray-800 rounded-full p-2 shadow-md hover:bg-gray-100",
                                  title: "View Full Image"
                                }, _cache[32] || (_cache[32] = [
                                  _createElementVNode("i", { class: "fa fa-expand" }, null, -1)
                                ]), 8, _hoisted_50)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Close")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", {
              class: "modal-title",
              id: "rejectModalLabel"
            }, "Reject Transfer Request"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _cache[37] || (_cache[37] = _createElementVNode("label", {
                for: "rejectReason",
                class: "form-label"
              }, "Reason for Rejection", -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "rejectReason",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rejectReason).value = $event)),
                class: "form-control",
                rows: "3",
                placeholder: "Enter reason for rejection",
                required: ""
              }, null, 512), [
                [_vModelText, rejectReason.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _cache[38] || (_cache[38] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Cancel", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: handleReject,
              disabled: !rejectReason.value
            }, " Reject ", 8, _hoisted_57)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("h5", _hoisted_62, [
              _cache[40] || (_cache[40] = _createTextVNode(" Image Gallery ")),
              _createElementVNode("span", _hoisted_63, _toDisplayString(currentImageIndex.value + 1) + " of " + _toDisplayString(galleryImages.value.length), 1)
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-close-white",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                (isImageLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, _cache[42] || (_cache[42] = [
                      _createElementVNode("div", {
                        class: "spinner-border text-light",
                        role: "status"
                      }, [
                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                      ], -1)
                    ])))
                  : _createCommentVNode("", true),
                (imageLoadError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _cache[43] || (_cache[43] = _createElementVNode("i", { class: "fa fa-exclamation-circle text-danger" }, null, -1)),
                      _cache[44] || (_cache[44] = _createElementVNode("p", { class: "mt-2" }, "Failed to load image", -1)),
                      _createElementVNode("button", {
                        class: "btn btn-outline-light btn-sm mt-2",
                        onClick: retryLoadImage
                      }, " Retry ")
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock("img", {
                  src: currentGalleryImage.value,
                  key: currentGalleryImage.value,
                  class: _normalizeClass(["main-gallery-image", { 'hide': isImageLoading.value || imageLoadError.value }]),
                  onLoad: handleImageLoad,
                  onError: handleImageError,
                  alt: "Gallery Image"
                }, null, 42, _hoisted_69))
              ]),
              (galleryImages.value.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: previousImage,
                    class: "nav-button nav-button-left",
                    disabled: isImageLoading.value
                  }, _cache[45] || (_cache[45] = [
                    _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
                  ]), 8, _hoisted_70))
                : _createCommentVNode("", true),
              (galleryImages.value.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: nextImage,
                    class: "nav-button nav-button-right",
                    disabled: isImageLoading.value
                  }, _cache[46] || (_cache[46] = [
                    _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
                  ]), 8, _hoisted_71))
                : _createCommentVNode("", true),
              (galleryImages.value.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _createElementVNode("div", {
                      class: "thumbnails-scroll",
                      ref_key: "thumbnailsContainer",
                      ref: thumbnailsContainer
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(galleryImages.value, (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          onClick: ($event: any) => (setCurrentImage(index)),
                          class: _normalizeClass(["thumbnail-item", { 'active': currentImageIndex.value === index }])
                        }, [
                          _createElementVNode("img", {
                            src: image,
                            alt: 'Thumbnail ' + (index + 1),
                            class: "thumbnail-image",
                            loading: "lazy"
                          }, null, 8, _hoisted_74),
                          (currentImageIndex.value === index)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                _createElementVNode("span", _hoisted_76, _toDisplayString(index + 1), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_73))
                      }), 128))
                    ], 512)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _cache[48] || (_cache[48] = _createElementVNode("div", { class: "flex-1 text-left" }, [
              _createElementVNode("span", { class: "text-sm text-gray-400" }, [
                _createTextVNode(" Press "),
                _createElementVNode("kbd", { class: "px-2 py-1 bg-gray-800 rounded border border-gray-700" }, "←"),
                _createTextVNode(" or "),
                _createElementVNode("kbd", { class: "px-2 py-1 bg-gray-800 rounded border border-gray-700" }, "→"),
                _createTextVNode(" to navigate ")
              ])
            ], -1)),
            _createElementVNode("button", {
              class: "btn btn-outline-light",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (openImageInNewTab(currentGalleryImage.value))),
              disabled: isImageLoading.value || imageLoadError.value
            }, _cache[47] || (_cache[47] = [
              _createElementVNode("i", { class: "fa fa-external-link-alt mr-1" }, null, -1),
              _createTextVNode(" Open Full Size ")
            ]), 8, _hoisted_78),
            _cache[49] || (_cache[49] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Close", -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})